<div>{{ widthPercentage() }}</div>
